"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouting = createRouting;
const factories_1 = require("./factories/index.js");
function createRouting({ i18n, pageSlugs, prefixSlugs }) {
    const PREFIXES = (0, factories_1.createPrefixes)({ i18n, prefixSlugs });
    const { routes } = (0, factories_1.createRouteBuilders)({ i18n, pageSlugs });
    const { canonical } = (0, factories_1.createCanonical)({ routes });
    const { mappedParams } = (0, factories_1.createParamsMapper)({ prefixes: PREFIXES });
    const { parsedParams } = (0, factories_1.createRouteParsers)({ pageSlugs });
    return { routes, canonical, mappedParams, parsedParams, PREFIXES };
}
